import React, { useState } from "react";
import Aside from "../modules/SideNav/Aside";
import Dashboard from "../components/Dashboard/Dashboard";

function Layout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <>
      {/* <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      /> */}
      <Dashboard handleToggleSidebar={handleToggleSidebar} />
    </>
  );
}

export default Layout;
